import { Box, Card, Stack, Typography } from "@mui/material";
import type { Ref } from "react";
import type { Capability } from "./investorPortalCapabilities";

interface Props {
  capability: Capability;
  counter: string;
  ref?: Ref<HTMLDivElement>;
}

const CapabilitySection = ({ capability, counter, ref }: Props) => {
  const titleId = `capability-${capability.key}-title`;

  return (
    <Card ref={ref} component="section" variant="outlined" aria-labelledby={titleId} sx={{ scrollMarginTop: 24 }}>
      <Stack spacing={1} sx={{ px: 3, pt: 3, pb: 2.5 }}>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 700 }}>
          {counter}
        </Typography>
        <Typography id={titleId} variant="h4" component="h2">
          {capability.title}
        </Typography>
        <Typography color="textSecondary" sx={{ maxWidth: 560 }}>
          {capability.description}
        </Typography>
      </Stack>
      <Box sx={{ px: 2, py: 2.5, bgcolor: "subtleSurfaceBg" }}>
        <Box
          component="img"
          src={capability.imageSrc}
          alt={capability.title}
          sx={{ display: "block", width: "100%", height: "auto", aspectRatio: capability.imageAspectRatio }}
        />
      </Box>
    </Card>
  );
};

export default CapabilitySection;
